import { Model } from '@vuex-orm/core'

export default class Group extends Model {
    static get entity () {
        return 'groups'
    }

    static fields () {
        return {
            id: this.uid(),
            name: this.string(''),
            sysname: this.string(''),
            code: this.string(''),
            fullname: this.string(''),
            cpoId: this.string(null).nullable(),
            parentId: this.attr('').nullable(),
            parent: this.belongsTo(Group, 'parentId'),
            children: this.hasMany(Group, 'parentId'),
        }
    }
}
